import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ModelAnimationViewer } from './ModelAnimationViewer';
import { resourceApi } from '../NejlikaApi';
import Cookies from 'js-cookie';

interface AnimationEmbeddedProps {
}

export const AnimationEmbedded: React.FC<AnimationEmbeddedProps> = ({ }) => {
    const  { "*": modelPath } = useParams();
    const [modelUrl, setModelUrl] = useState<string | null>(null);

    const project = Cookies.get('project') || "default";

    useEffect(() => {
        if (modelPath) {
            resourceApi.getGeometryUrl(project, modelPath).then(setModelUrl);
        }
    }, [modelPath, project]);

    if (!modelPath || !modelUrl) {
        return null;
    }
    
    return (
        <div style={{ width: "100vw", height: "100vh", position: "relative" }}>
            <ModelAnimationViewer modelUrl={modelUrl} />
        </div>
    );
}